import PSPPaymentDurationCard from "./PSPPaymentDurationCard";
import api from "~/api";
import { useTranslation } from "react-i18next";

const PSPPaymentDurationByAcquirers = () => {
  const { t } = useTranslation();
  const getPSPPaymentDurationMetrics = async (
    params: MetricsAPI.GetMetricQuery
  ) => {
    try {
      const { data } = await api.metrics.getPSPPaymentDurationByAcquirers(
        params
      );
      if (data) {
        return data.data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <PSPPaymentDurationCard
      title={`${t("title.pspPaymentDurationBy")} ${t("title.metricOfAcquirers")}`}
      onUpdate={getPSPPaymentDurationMetrics}
    />
  );
};

export default PSPPaymentDurationByAcquirers;
